import { render, staticRenderFns } from "./about.vue?vue&type=template&id=603e92f4&lang=pug&"
var script = {}
import style0 from "./about.vue?vue&type=style&index=0&scope=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "about.vue"
export default component.exports